import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import { useReports } from '@/pages/organizations/detail/reports'
import { includes } from 'lodash'
import OverviewPageDefault from '@/features/reports/components/pages/OverviewPageDefault'
import OverviewPageForDistrictLike from '@/features/reports/components/pages/OverviewPageForDistrictLike'

export const Route = createFileRoute('/app/organizations/$organizationId/reports/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { organization } = useOrganization()
  const { userCanViewAssessments, userCanViewAssessmentsChild, userCanViewTeam, orgType } = useReports()

  if (includes(['district', 'cmo', 'esd'], orgType?.machine_name)) {
    return (
      <OverviewPageForDistrictLike
        userCanViewAssessments={userCanViewAssessments}
        userCanViewAssessmentsChild={userCanViewAssessmentsChild}
        userCanViewTeam={userCanViewTeam}
        organization={organization}
      />
    )
  } else {
    return (
      <OverviewPageDefault
        userCanViewAssessments={userCanViewAssessments}
        organization={organization}
      />
    )
  }
}
